import React from 'react';
import {Handle, Position, ReactFlowInstance} from 'reactflow';

import {AddNodeDropdown} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/AddNodeDropdown';
import {ProcessFlowchartNodeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {GetAddNodeOptionsForRightHandle} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import AddNodeHandle, {AddNodeHandleProps} from 'ui-library/reactflow/handles/AddNodeHandle';
import {defaultNodeHandleIdGenerator} from 'ui-library/reactflow/nodes/SimpleBenchlingNode/sub-components/SimpleBenchlingNodeHandle';

export default function createHeaderPropsForNode(
  nodeData: {
    id: string;
    nodeName: string;
    nodeIcon?: BenchlingIconName;
    nodeSecondaryInfo?: string;
    nodeType: ProcessFlowchartNodeType;
    position: {x: number; y: number};
    getAddNodeOptionsForRightHandle?: GetAddNodeOptionsForRightHandle;
  },
  reactFlowInstance: ReactFlowInstance,
  hasLeftHandle: boolean = true,
  hasRightHandle: boolean = true
): {
  title: string;
  subTitle?: string;
  leftIcon?: BenchlingIconName;
  leftHandle?: React.ReactNode;
  rightHandle?: React.ReactNode;
} {
  const {id, nodeName, nodeIcon, nodeSecondaryInfo} = nodeData;
  const addNodesOptions = nodeData.getAddNodeOptionsForRightHandle?.(nodeData.id, reactFlowInstance);
  const addNodeHandleProps: Pick<AddNodeHandleProps, 'renderPopoverContent' | 'onClick'> = {};
  if (addNodesOptions != null) {
    // If there is exactly one option, we perform that action on click instead of showing a popover menu.
    if (addNodesOptions.length === 1) {
      addNodeHandleProps.onClick = addNodesOptions[0].onSelect;
    } else if (addNodesOptions.length > 1) {
      addNodeHandleProps.renderPopoverContent = () => <AddNodeDropdown options={addNodesOptions} />;
    }
  }

  return {
    title: nodeName,
    subTitle: nodeSecondaryInfo,
    leftIcon: nodeIcon,
    leftHandle: hasLeftHandle ? (
      <Handle id={defaultNodeHandleIdGenerator(id, 'target')} type="target" position={Position.Left} />
    ) : null,
    rightHandle: hasRightHandle ? (
      <AddNodeHandle
        id={defaultNodeHandleIdGenerator(id, 'source')}
        type="source"
        isConnectable={true}
        {...addNodeHandleProps}
      />
    ) : null,
  };
}
